import { render } from "./NpsCard.vue?vue&type=template&id=019767c4"
import script from "./NpsCard.vue?vue&type=script&lang=js"
export * from "./NpsCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__